module.exports = __webpack_public_path__ + "img/line-friend-qrcode.9b849b28.png";